import styled from "styled-components";

const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export { SearchWrapper };